/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * CALCLISTへの追加レスポンス
 * @export
 * @interface AddCalcListResponse
 */
export interface AddCalcListResponse {
    /**
     * 追加が成功したかどうか
     * @type {boolean}
     * @memberof AddCalcListResponse
     */
    success: boolean;
    /**
     * メッセージ
     * @type {string}
     * @memberof AddCalcListResponse
     */
    message: string;
}

/**
 * Check if a given object implements the AddCalcListResponse interface.
 */
export function instanceOfAddCalcListResponse(value: object): value is AddCalcListResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function AddCalcListResponseFromJSON(json: any): AddCalcListResponse {
    return AddCalcListResponseFromJSONTyped(json, false);
}

export function AddCalcListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCalcListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function AddCalcListResponseToJSON(json: any): AddCalcListResponse {
    return AddCalcListResponseToJSONTyped(json, false);
}

export function AddCalcListResponseToJSONTyped(value?: AddCalcListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

